module.exports = __webpack_public_path__ + "img/cursor.448ddffa.svg";